module.exports = __webpack_public_path__ + "media/images/Gift-82d5f2a4.png";